import type { SessionStepModule } from '../types';
import { AadhaarDetail } from './AadhaarDetail';
import { AadhaarStepRunner } from './AadhaarStepRunner';
import { isAadhaarStep } from './aadhaar.utils';

// Aadhaar Verification step module. APIs: DigiLocker (PIN / PIN-less) and OVSE
// are async webhook flows (in-app popup + poll); Aadhaar OCR is synchronous.
export const aadhaarStepModule: SessionStepModule = {
  key: 'aadhaar',
  matches: isAadhaarStep,
  Runner: AadhaarStepRunner,
  Detail: AadhaarDetail,
};
